// components/PageElements/PageContainer/PageContainer.tsx
import React from 'react';
import styles from './PageContainer.module.css';
import Footer from '../../Footer/Footer';

interface PageContainerProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, hideFooter = false }) => {
  return (
    <div className={styles.container}>
      {children}
      {!hideFooter && <Footer />}
    </div>
  );
};

export default PageContainer;